import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from '@mui/material';
import { LABELS } from './AffectedProductsTab.constants';

export const CommentDialog = ({ open, onClose, comment }) => (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>{LABELS.COMMENT_DETAILS}</DialogTitle>
        <DialogContent>
            <Typography variant="body1" sx={{ mt: 1 }}>
                {comment}
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} color="primary">
                {LABELS.CLOSE}
            </Button>
        </DialogActions>
    </Dialog>
);